export default "__VITE_ASSET__mNsVMyGh__"